module.exports = __webpack_public_path__ + "static/media/cursor-pointer.48bd67b7.svg";